// =========================
// main.js
// =========================
import TranslationService from "./services/TranslationService";
const NotificationService = require("./services/NotificationService");

// core version + navigation, pagination modules:
import Swiper, { Navigation, Pagination, Autoplay } from "swiper";

// configure Swiper to use modules
Swiper.use([Navigation, Pagination, Autoplay]);

$(document).ready(function()
{
    const isMobile = window.matchMedia("only screen and (max-width: 760px)").matches;

    let lastClickedItem = 0;

    if ($(".widget-preorder span").length > 0)
    {
        $(".widget-availability").remove();
    }

    setTimeout(function()
    {
        // on click of rating stars -> scroll to rating widget
        if ($(".feedback-stars-overlay-wrap").length)
        {
            if ($(".widget-feedback .feedback-stars-average").length)
            {
                $(".widget-feedback-average").on("click", function()
                {
                    $("html, body").animate({ scrollTop: $(".widget-feedback .feedback-stars-average").offset().top - 200 }, 500);
                });
            }
        }

        // on click on questions-to-item -> scroll to question widget
        if ($(".question-to-item-link").length)
        {
            if ($(".question-widget").length)
            {
                $(".question-to-item-link").on("click", function()
                {
                    $("html, body").animate({ scrollTop: $(".question-widget").offset().top - 200 }, 500);
                });
            }
        }

        // shopvote badge
        if ($(".reviewpage-13996").length || $("#sv-badget-box.sv-badget-98x98").length)
        {
            let badge = null;

            if ($(".reviewpage-13996").length)
            {
                badge = $(".reviewpage-13996");
            }
            else if ($("#sv-badget-box.sv-badget-98x98").length)
            {
                badge = $("#sv-badget-box.sv-badget-98x98");
            }

            // element ausblenden, wenn die Bildschrimbreite kleiner ist als 1268px
            // und beim scrollen
            $(window).on("scroll", function()
            {
                if ($(window).width() < 1400)
                {
                    badge.hide();
                }
                else
                {
                    // nur einblenden, wenn das badge nicht auf folgenden Seiten ist
                    //    &.category-basket,
                    //     &.page-login,
                    //     &.page-checkout,
                    //     &.page-confirmation
                    if ($(".category-basket").length === 0 && $(".page-login").length === 0 && $(".page-checkout").length === 0 && $(".page-confirmation").length === 0)
                    {
                        badge.show();
                    }
                }

                // wenn man wieder nach oben scrollt, dann wieder einblenden
                if ($(window).scrollTop() === 0)
                {
                    // nur einblenden, wenn das badge nicht auf folgenden Seiten ist
                    //    &.category-basket,
                    //     &.page-login,
                    //     &.page-checkout,
                    //     &.page-confirmation
                    if ($(".category-basket").length === 0 && $(".page-login").length === 0 && $(".page-checkout").length === 0 && $(".page-confirmation").length === 0)
                    {
                        badge.show();
                    }
                }
            });
        }
    }, 1000);

    const swiperWrapper = $(".home-slider__swiper");

    if (swiperWrapper.length)
    {
        const crossSwiper1 = new Swiper(".home-slider__swiper", {
            spaceBetween: 10,
            slidesPerView: 1,
            loop: true,
            navigation: {
                nextEl: ".home-slider__slider-next",
                prevEl: ".home-slider__slider-prev"
            },
            autoplay: {
                delay: 3500
            },
            pagination: {
                el: ".swiper-pagination",
                clickable: true
            }
        });

        // stop autoslide on hover
        swiperWrapper.hover(function()
        {
            crossSwiper1.autoplay.stop();
        }, function()
        {
            crossSwiper1.autoplay.start();
        });

        // stop autoslide on touchin
        swiperWrapper.on("touchstart", function()
        {
            crossSwiper1.autoplay.stop();
        });
        swiperWrapper.on("touchend", function()
        {
            crossSwiper1.autoplay.start();
        });

        window.dispatchEvent(new Event("resize"));

        crossSwiper1.on("slideChange", function()
        {
            window.dispatchEvent(new Event("resize"));
        });
    }

    if ($(".brand-slider__swiper").length && !isMobile)
    {
        const crossSwiper2 = new Swiper(".brand-slider__swiper", {
            spaceBetween: 10,
            slidesPerView: 5,
            loop: false,
            navigation: {
                nextEl: ".brand-slider__slider-next",
                prevEl: ".brand-slider__slider-prev"
            }
        });

        window.dispatchEvent(new Event("resize"));

        crossSwiper2.on("slideChange", function()
        {
            window.dispatchEvent(new Event("resize"));
        });
    }

    if ($(".single-cross__swiper-container").length && !isMobile)
    {
        const crossSwiper3 = new Swiper(".single-cross__swiper-container", {
            spaceBetween: 10,
            slidesPerView: 5,
            loop: false,
            navigation: {
                nextEl: ".single-cross__slider-next",
                prevEl: ".single-cross__slider-prev"
            }
        });

        window.dispatchEvent(new Event("resize"));

        crossSwiper3.on("slideChange", function()
        {
            window.dispatchEvent(new Event("resize"));
        });
    }

    $("body").on("click", ".single__inquiry, .js-get-current-variation", (event) =>
    {
        lastClickedItem = $(event.currentTarget).data("item");
    });

    $("#inquiry__send").click(function(event)
    {
        event.preventDefault();
        $(".error").removeClass("error");

        let isAllFilled = true;

        const mailInput = $("#inquiry-mail");

        if (mailInput.val() === "" || !validateEmail(mailInput.val()))
        {
            mailInput.parent().addClass("error");
            isAllFilled = false;

            NotificationService.error(
                TranslationService.translate("LucxCeres::Template.checkAddressFormFieldsMail")
            );
        }

        if ($("#dsgvo-inquiry").prop("checked") === false)
        {
            $("#dsgvo-inquiry").parent().addClass("error");
            isAllFilled = false;

            NotificationService.error(
                TranslationService.translate("Ceres::Template.contactAcceptFormPrivacyPolicy", { hyphen: "&shy;" })
            );
        }

        if (isAllFilled)
        {
            const mailObj =
                {
                    mail: mailInput.val(),
                    notify: $("#inquiry-notify").prop("checked") ? 1 : 0,
                    message: "xx",
                    userMail: "xx",
                    subject: "xx",
                    type: "inquiry",
                    itemid: lastClickedItem
                };

            $.ajax({
                url: "https://www.lucx-angelsport.de/lucx/availability",
                type: "POST",
                async: true,
                data: mailObj,
                success: function(data, textStatus, jqXHR)
                {
                    // success
                    $("#inquiry").modal("hide");

                    NotificationService.success(
                        TranslationService.translate("LucxCeres::Template.inquirySent")
                    );
                },
                error: function(data)
                {
                    // console.log(data);
                }
            });
        }
    });
});

function validateEmail(email)
{
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;

    return re.test(String(email).toLowerCase());
}

$(window).scroll(function()
{
    const scroll = $(window).scrollTop();

    if (scroll >= 120)
    {
        $(".fixed-top").addClass("scrolled");
    }
    else
    {
        $(".fixed-top").removeClass("scrolled");
    }
});

